import { of } from 'rxjs';
import {
	ICoreRoutes,
	IPageMetadata,
	ITypeRoute,
	ITypeRouteAction,
	RouteInitializer
} from '../../pages/type-routes/type-route.models.js';
import { TrainerDashboardComponent } from 'src/app/modules/home/trainer-dashboard.component.js';

export interface ITrainerHomeRoutes extends ICoreRoutes {
	dashboard: ITypeRoute<
		undefined,
		{
			main: ITypeRouteAction<undefined>;
		}
	>;
}

export const trainerHomeRoutes: RouteInitializer<ITrainerHomeRoutes> = {
	dashboard: {
		mainPath: 'trainer',
		uniqueId: 'trainerDashboard',
		parentRoutes: (context) => [],
		loadSharedData: (context) => {
			return of(undefined);
		},
		menuItems: (context) => [],
		children: {
			main: {
				uniqueId: `trainerDashboard`,
				component: TrainerDashboardComponent,
				getMetadata: (data) => {
					const metadata: IPageMetadata = {
						title: 'Dashboard'
					};
					return metadata;
				}
			}
		}
	}
};
